// eslint-disable-next-line import/prefer-default-export
export const SET_EDITING_INVESTMENT = 'SET_EDITING_INVESTMENT';
export const SET_INVESTMENTS_LOADING = 'SET_INVESTMENTS_LOADING';
